import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress benign ResizeObserver loop message (browser quirk, not an app bug)
const resizeObserverErr = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
window.addEventListener('error', (e) => {
    if (resizeObserverErr.test(e.message)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return true;
    }
});
window.addEventListener('unhandledrejection', (e) => {
    if (e.reason?.message && resizeObserverErr.test(e.reason.message)) {
        e.preventDefault();
    }
});

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
